import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./BillingAddressForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeBillingAddress} from "../../actions/AccountApiActions";
import {fromJS, List} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {getUSStates, getCanadaProvinces, isUS, isCanada} from "../../lib/CountriesAndStates";
import {hasStateProvince} from "../../lib/AddressRules";
import {validateBillingAddress} from "../../lib/AddressValidation";

function validateForm(values, props) {
  return validateBillingAddress(values).toJS();
}

class ChangeBillingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      accountId: this.props.accountId,
      name: values.get("name"),
      addressAddressLine1: values.get("addressAddressLine1"),
      addressAddressLine2: values.get("addressAddressLine2", ""),
      addressCity: values.get("addressCity"),
      addressPostcode: values.get("addressPostcode"),
      addressStateProvince: values.get("addressStateProvince"),
      addressCountryCode: values.get("addressCountryCode")
    }

    return this.props.changeBillingAddress(updatedValues)
      .then((response) => {
        if (response.data.changeBillingAddress.errors.length <= 0) {
          this.props.cancelChangeBillingAddress();
        } else {
          let errors = createValidationErrors(response.data.changeBillingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeBillingAddress();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let countries = fromJS(data.countries);
    let account = fromJS(data.billingAccount)
    let initialValues = {}
    if (account.get("addressStatus") === "provided") {
      initialValues = account.get("address").delete("__typename");
    }
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = getUSStates();
    if (this.props.showCanadaProvinces) stateProvinces = getCanadaProvinces();

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        countries={countries}
        stateProvinces={stateProvinces}
        showStateProvince={this.props.showStateProvince}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}


const GET_BILLING_ADDRESS = gql`
  query billingAccount($accountId: ID!) {
    billingAccount(accountId: $accountId) {
      address {
        name
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
      }
      addressStatus
    }
    countries {
      code
      name
    }
  }
`;

const CHANGE_BILLING_ADDRESS = gql`
  mutation changeBillingAddress($data: BillingAddressInput!) {
    changeBillingAddress(input: $data) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(GET_BILLING_ADDRESS, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(CHANGE_BILLING_ADDRESS, {
    props: ({ mutate }) => ({
      changeBillingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const selector = formValueSelector("BillingAddressForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "addressCountryCode")),
    showCanadaProvinces: isCanada(selector(state, "addressCountryCode")),
    showStateProvince: hasStateProvince(selector(state, "addressCountryCode"))
  }
}


export default connect(mapStateToProps, {cancelChangeBillingAddress})(withQueries(ChangeBillingAddressFormContainer));

